import { useState } from "react";

import { makeGetApiCall } from "../../shared/makeApiCall";

import { SimpleNotificationType } from "../../components/SimpleNotification";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function QuickbooksLoginViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: SimpleNotificationType.Success,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const onLoginPress = async function () {
    // params can be an object like { code, state, realmId }
    setLoading(true);
    let callResult;

    callResult = await makeGetApiCall(`quickbooks/connect`);
    setLoading(false);
    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        message: "Logging into Quickbooks",
        title: "Logging into Quickbooks",
        type: SimpleNotificationType.Success,
      });

      return callResult.data.auth; // should be the url to redirect
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(
        "Could not Finish Quickbooks Connection",
        callResult.message
      );
      return false;
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    onLoginPress,
    showSimpleNotification,
    setShowSimpleNotification,
  };
}
